import { I18n } from '@calendly/i18n';
import { ContextualBanner } from '@calendly/ui/components/contextual-banner';
import { ProTip } from '@calendly/ui/components/pro-tip';
import { HeadingText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { isFreeOrTrialSelector } from 'features/billing';
const unorderedListCss = "u1ow4t6b";
const UnorderedList = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'ul';
  return <Component ref={ref} {...restProps} className={classNames(unorderedListCss, props.className)} />;
});
const listItemWrapperCss = "lpvqtcp";
const ListItemWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(listItemWrapperCss, props.className)} />;
});
const proTipWrapperCss = "p1l8vo0z";
const ProTipWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(proTipWrapperCss, props.className)} />;
});

// i18n-tasks-use t('publisher.add_users_modal.value_prop_banner.trial.item_1.text')
// i18n-tasks-use t('publisher.add_users_modal.value_prop_banner.trial.item_1.tooltip')
// i18n-tasks-use t('publisher.add_users_modal.value_prop_banner.trial.item_2.text')
// i18n-tasks-use t('publisher.add_users_modal.value_prop_banner.trial.item_2.tooltip')
// i18n-tasks-use t('publisher.add_users_modal.value_prop_banner.trial.item_3.text')
// i18n-tasks-use t('publisher.add_users_modal.value_prop_banner.trial.item_3.tooltip')
// i18n-tasks-use t('publisher.add_users_modal.value_prop_banner.paid.item_1.text')
// i18n-tasks-use t('publisher.add_users_modal.value_prop_banner.paid.item_1.tooltip')
// i18n-tasks-use t('publisher.add_users_modal.value_prop_banner.paid.item_2.text')
// i18n-tasks-use t('publisher.add_users_modal.value_prop_banner.paid.item_2.tooltip')
// i18n-tasks-use t('publisher.add_users_modal.value_prop_banner.paid.item_3.text')
// i18n-tasks-use t('publisher.add_users_modal.value_prop_banner.paid.item_3.tooltip')
const ListItem = ({
  stage,
  item
}) => {
  const text = I18n.t(`publisher.add_users_modal.value_prop_banner.${stage}.item_${item}.text`);
  const tooltipText = I18n.t(`publisher.add_users_modal.value_prop_banner.${stage}.item_${item}.tooltip`);
  return <li data-component={`value-proposition-banner-item-${item}`}>
      <ListItemWrapper>
        {text}
        {tooltipText && <ProTipWrapper>
            <ProTip size="small" hideControls>
              {tooltipText}
            </ProTip>
          </ProTipWrapper>}
      </ListItemWrapper>
    </li>;
};
export const ValuePropBanner = () => {
  const isTrial = useSelector(isFreeOrTrialSelector);
  const isPaid = !useSelector(isFreeOrTrialSelector);
  return <div data-component="value-proposition-banner">
      <ContextualBanner variant="standard" spacingTop={16}>
        <HeadingText size="small">
          {I18n.t('publisher.add_users_modal.value_prop_banner.title')}
        </HeadingText>
        {isTrial && <UnorderedList>
            <ListItem stage="trial" item="1" />
            <ListItem stage="trial" item="2" />
            <ListItem stage="trial" item="3" />
          </UnorderedList>}
        {isPaid && <UnorderedList>
            <ListItem stage="paid" item="1" />
            <ListItem stage="paid" item="2" />
            <ListItem stage="paid" item="3" />
          </UnorderedList>}
      </ContextualBanner>
    </div>;
};

require("./value_prop_banner.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./value_prop_banner.js");